import { IApplicationContext } from 'shared/types/applicationContext';
import { IApplicationState, TReduxStore } from 'shared/types/redux';
import { createReduxStore } from 'shared/redux';

export function createApplicationState(context: IApplicationContext): TReduxStore {
  const { config } = context;

  const initialState = config.getStrict<IApplicationState>('initialState');

  return createReduxStore(initialState, context, true);
}
